module.exports = {"TXTWCL_Popular_Accumulators":{"id":"TXTWCL_Popular_Accumulators","defaultMessage":"Populære kombispil","ontario":"Populære kombispil"}}